import EdoSettingsBilling from './Billing';

export default EdoSettingsBilling;
